export default (id) => {
  switch (id) {
    case 1:
      return 'Launch is GO'

    case 2:
      return 'Launch is NO-GO'

    case 3:
      return 'Launch was a success'

    case 4:
      return 'Launch failed'

    case 5:
      return 'Unplanned hold'

    case 6:
      return 'Vehicle is in flight'

    case 7:
      return 'Partial Failure'
      
    default:

  }
}
